import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Box, Stack } from "@seneca/senekit";

import { getLastSession } from "seneca-common/features/session/selectors/session";

import { linkThroughQuitSessionModal } from "features/classroom/features/sidebar/features/common/utils/linkThroughQuitSessionModal";
import { useWarnOnNavigateAwayFromSession } from "features/classroom/hooks/useWarnOnNavigateAwayFromSession";
import SidebarHeaderUpper from "features/common/components/sidebar/components/SidebarHeader/components/SidebarHeaderUpper";
import { linkToDashboard } from "features/dashboard/links";

type Props = {
  courseId: string;
  currentSectionId?: string;
  handleToggle: () => void;
  sidebarOpen: boolean;
};

export default function SidebarHeader({
  handleToggle,
  sidebarOpen,
  courseId,
  currentSectionId
}: Props) {
  const location = useLocation();

  const warnBeforeNavigation = useWarnOnNavigateAwayFromSession();

  const sessionType = useSelector(getLastSession)?.sessionType!;

  const exitClassroomDestination = linkToDashboard();

  const linkToExitClassroom = linkThroughQuitSessionModal({
    warnBeforeNavigation,
    courseId,
    activeSectionId: currentSectionId,
    link: exitClassroomDestination,
    sessionType,
    currentLocation: location
  });

  return (
    <Box paddingX="xlarge">
      <Stack space="large">
        <SidebarHeaderUpper
          quitLink={linkToExitClassroom}
          handleToggle={handleToggle}
          sidebarOpen={sidebarOpen}
        />
      </Stack>
    </Box>
  );
}
